import script from "./TiktokWebhookAddEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokWebhookAddEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./TiktokWebhookAddEditDialog.vue?vue&type=style&index=0&id=8eb1ecb4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8eb1ecb4"]])

export default __exports__